<script setup>
import {computed, ref, watch} from 'vue'
import {useProductVariationsStore} from '@/stores/productVariations'

const props = defineProps({
    item: Object,
    value: Number
})

const productVariationsStore = useProductVariationsStore()

const items = ref(null)

const variationData = computed(() => {
    return props.item?.variationData
})

const description = computed(() => {
    return props.item?.description
})

watch(() => props.value, async (newValue) => {
    if (newValue) {
        items.value = await productVariationsStore.getVariation({
            productId: props.item?.itemId,
            variationId: newValue
        })
        return
    }
    items.value = null
}, {immediate: true})
</script>

<template>
    <dl v-if="variationData" class="dl-horizontal">
        <template v-for="(o, index) in variationData" :key="index">
            <dt>{{ o.option }}</dt>
            <dd>{{ o.variable }} {{ o.metric || o.imperial }}</dd>
        </template>
    </dl>
    <!-- deprecated -->
    <div v-else-if="typeof description === 'string'"></div><!-- FS's description text -->
    <dl v-else-if="description" class="dl-horizontal">
        <template v-for="(variableName, optionName) in description"  :key="optionName">
            <dt>{{ optionName }}</dt>
            <dd>{{ variableName }}</dd>
        </template>
    </dl>
</template>